'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {useLocation} from 'react-router';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {i_company_name, company_display_names} from './vs_toolip';
import styles from './vs_toolip.module.less';
import hola_opt from 'hola_opt';
import {obj_to_arr} from '../use_cases/use_case_faq';
import {Faq_section} from '../toolip/faq_section';
import {Input} from '../../../../hola/pub/lib/input';
import {Dynamic_heading, Title_header_select} from '../../../../shared/editor/title_header_select';
import {use_data_provider} from '../../../../hola/pub/lib/use_data_provider';

const get_faq_for_company = (company: i_company_name, section?: string)=>{
    const collection = hola_opt.intercom_articles?.[section || 'TOOLIP VS.']
        || {};
    return collection[company_display_names[company] || company] || [];
};

export interface i_vs_faq_props {
    company?: i_company_name;
    title?: string;
    title_tag?: string;
    section?: string;
}
interface i_vs_faq_editor_props {
    value:i_vs_faq_props;
    on_change: (v:i_vs_faq_props)=>void
}

export const Vs_faq = ({company, title, title_tag, section}: i_vs_faq_props)=>{
  const {theme} = useContext(Settings_context);
  const faq_data = obj_to_arr(get_faq_for_company(company, section));
  const {pathname} = useLocation();
  const get_data_id =()=>`schema-faqs-${pathname}`;
  const {data} = use_data_provider(get_data_id);
  const is_editor_change =
      JSON.stringify(data?.result?.data) !== JSON.stringify(faq_data);

  return <div className={cn(styles.faq, theme.container)}>
    <Dynamic_heading tag={title_tag || 'h2'}>{title || 'Some FAQs'}
    </Dynamic_heading>
    <Faq_section custom_questions={is_editor_change
      ? faq_data : data?.result?.data} no_title color='transparent'/>
  </div>;
};

export const Vs_faq_editor = ({value, on_change}: i_vs_faq_editor_props)=>{
  return <div>
    <Input
      value={value.title || ''}
      on_change={v=>on_change({...value, title: v})}
      label='Section Title'
    />
    <Title_header_select value={value.title_tag} on_select={v=>
      on_change({...value, title_tag: v})}/>
    <Input
      value={value.title || ''}
      on_change={v=>on_change({...value, section: v})}
      label='Intercom Section'
    />
    <Input
      value={value.company || ''}
      on_change={v=>on_change({...value, company: v})}
      label='Company Name ( lunaproxy, iproyal, packetstream, dataimpulse,
        webshare, bytio, soax, croxyproxy, froxy) OR folder in sec'
    />
  </div>;
};
